import {DatePipe} from '@angular/common';
import { Component, OnInit, Inject, ViewChild,ElementRef,OnDestroy,ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { StaffData,  alertinfo, reNotifyAlert, getRenotityData } from '../home';
import { DOCUMENT } from '@angular/platform-browser';
import { map, startWith, switchMap,takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ClearalertComponent } from './clearalert/clearalert.component';
import { appsettings, enumAlertType, enumAlertSubType, enumAlertStatus,enumAlertAckStatus, enumUIFeatureView, enumUIAction, enumUIView, alert_deviceType, Alert_Event_Type } from '../../../app-settings';
import { SharedAlertLoadData,SharedAlertData, NearestStaffdata, cancelAlert } from '../../../api';
import { HomeService } from '../home.service';
import { AlertSharedService } from '../../../_services/index';
import { notification_line1,notification_line2,notification_line3,notification_ackinfo,notification_neareststaff_heading,SessionCheck} from '../../../app-general';
import { notification_neareststaff_details,notification_buttons,notification_staffinfomration,secondsToHms, generateAlertMessage, getFeatureNeedtoShow} from '../../../app-general';
import { RollbarService } from '../../../rollbar';
import { AppComponent } from '../../../app.component';
import { ConfirmMessageComponent } from '../../../confirm-message/confirm-message.component';
import { HttpClient } from '@angular/common/http';
import * as Rollbar from 'rollbar';
import { ApiService } from '../../../api.service';
//import { NgxSpinnerService } from 'ngx-spinner';
import * as _ from 'lodash';


@Component({
    selector: 'app-alertnotification',
    templateUrl: './alertnotification.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./alertnotification.component.scss']
})

 
export class AlertnotificationComponent implements OnInit,OnDestroy {

   // public static isnotifyinfraClosed = true;
    watcher: Subscription;
    columns: number = 4;
    htmlToAdd;
    htmlToAddload;
    Imgurl: string = appsettings.IMAGE_FOLDER;
    residentImgUrl: string = appsettings.RESIDENT_FOLDER;
    staffImgUrl: string = appsettings.STAFF_FOLDER;
    Staffdata: StaffData[];
    NearestStaffdata: NearestStaffdata[];
    
    checknetwork;
    AlertID;
    AlertType;
    AlertData;
    AlertInfo;
    RoomID;
    FloorID;
    SharedAlertLoadDetails: SharedAlertLoadData;
    alertinfofromshared: SharedAlertData[];
    alertdata: alertinfo[]
    notify_alive = true;
    pollingData: any;
    getalertinfo;
    notify_status = false;

    notificationTime1;
    notificationTime2;
    notificationTime3;
    intervalId;
    notifycurrentTime1 : string;
    notifycurrentTime2 : string;
    notifycurrentTime3 : string;
    htmlcontent;
    alertnotifytime;
    _alertMinutes;
    chkalertType;
    getclassname = "";
    checkdayforall = 0;
    checktimeforalert = 0;
    getcurrentseconds;

    updatehours1;
    updateminutes1;
    updateseconds1;    
    updatehours2;
    updateminutes2;
    updateseconds2;

    updatehours3;
    updateminutes3;
    updateseconds3;
    loading = false;
    AlertResStaff;
    DeviceSubType;
    DeviceType;
    CountNotifyFirstTest = 0;
    alertreturnVal = 0;
    SiteId = '1';
    LocationType;
    AlertApproxlocation;
    getNotificationdetails;
    cancel_TagId;
    private _onDestroy: Subject<void> = new Subject<void>();

    private ReloadOpenAlertURL = appsettings.URLinfo+'reloadOpenAlerts';
    public reload_open_Alerts;
    constructor(private datePipe: DatePipe,public dialog: MatDialog, private homeService: HomeService,private alertSharedService: AlertSharedService, @Inject(DOCUMENT) private document: any, mediaObserver: MediaObserver, @Inject(RollbarService) private rollbar: Rollbar, public thisDialogRef: MatDialogRef<AlertnotificationComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,private http: HttpClient,private apiService: ApiService) {
     try {  
                this.AlertID = data.AlertId;
                this.AlertType = data.AlertType;
                this.RoomID = data.RoomId;
                this.FloorID = data.FloorId;
                this.AlertData = data.AlertData;
                this.AlertResStaff = data.AlertResStaff;
                this.DeviceSubType = data.DeviceSubType;
                this.DeviceType = data.DeviceType;
                this.Staffdata = data.Staffdata;
                this.LocationType = data.LocationType
                
                this.NearestStaffdata = data.NearestStaffdata;
              
                this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
                    if (change) {
                        if (change.mqAlias == 'xs') {
                            this.columns = 1;
                        }
                        else if (change.mqAlias == 'sm') {
                            this.columns = 1;
                        }
                        else {
                            this.columns = 2;
                        }
                    }
                });   
        
        }
    catch (err) {
        throw new Error('alertnotification.component.ts' + ' - constructor() - ' + err.message);
      }  

    }
    ngOnInit() {
        try {
            
            this.alertSharedService.currentSharedAlert().pipe(takeUntil(this._onDestroy)).subscribe((SharedAlertDetails: SharedAlertData[]) => { 
                this.alertinfofromshared = SharedAlertDetails;    
                if (this.alertinfofromshared != undefined && this.AlertID != undefined) {
                    var _AlertID=this.AlertID;
                    this.AlertData = this.alertinfofromshared.filter(function (e) {
                        return e.AlertId == _AlertID
                    });      
                    
                    this.htmlToAdd = this.shownotificationDetails(this.NearestStaffdata, this.Staffdata, this.AlertData, this.AlertID, this.RoomID, this.FloorID);
                }            
             });

            this.alertSharedService.currentsharedAlertload().pipe(takeUntil(this._onDestroy)).subscribe((SharedAlertLoadDetails: SharedAlertLoadData) => { this.SharedAlertLoadDetails = SharedAlertLoadDetails; });
            this.htmlToAdd = this.shownotificationDetails(this.NearestStaffdata, this.Staffdata, this.AlertData, this.AlertID, this.RoomID, this.FloorID);
        }
        catch (err) {
            throw new Error('alertnotification.component.ts' + ' - ngOnInit() - ' + err.message);
        }
    }

    getRenotifyData()
    {
        var clicknotifyItem : getRenotityData = 
        {
            siteId: this.SiteId,
            authKey: localStorage.getItem("Authkey"),
            alertId: parseInt(this.AlertID),
            dateFormat:localStorage.getItem("dateFormat"),
            cancelOrCompleteSec:localStorage.getItem("PAST_ALERT_LINGER")
        }        
        this.homeService.getRenotifyData(clicknotifyItem).pipe(takeUntil(this._onDestroy))
        .subscribe((alertdata: any[]) => {                                                          
            this.alertdata = alertdata;    
            this.getNotifyData();        
        });	
    }
     getNotifyData(): void
     {         
     	this.htmlToAdd = this.shownotificationDetails(this.NearestStaffdata, this.Staffdata,this.alertdata,this.AlertID,this.RoomID,this.FloorID);
     }
    
    // close alert Notification Dialog
    public onCloseNotifyAlert = () => {
        
        this.notify_alive = false;
        this.notify_status = false;
        this.intervalId = 0;    
        this.thisDialogRef.close('Cancel');
        if(!SessionCheck(this.router))
        {
            return;
        }
    }

    shownotificationDetails(NearestStaffDetails,staffdetails,AlertData,AlertID,RoomID,FloorID) {
        try { 
            if(!SessionCheck(this.router))
            {
                this.thisDialogRef.close('Cancel');
                return;
            }        
                var item = { SiteId: "1" };               
                if(this.notify_status == true)
                {                       
                    AlertData = []; 
                    //AlertData = this.alertSharedService;
                     AlertData = this.alertdata;                                                 		       
                }
               
                var staffData; 
               
                var AlertNotify=AlertData ;
                
                this.notify_alive = true;
                this.loading = false;
                let elementcontent = document.getElementById('divnotifycontent');
                    elementcontent.className = 'divNotify enablecontent' 
              
                var alertlevelImg = '';
                for (let AlertNotifyData of AlertNotify) {
                    var strNotification = "";                      
                        alertlevelImg = "assets/images/" + AlertNotifyData.LevelPhoto;                    
                    var Staffphoto = this.staffImgUrl + AlertNotifyData.StaffPhoto;
                    var Alert_TimeofAlert = AlertNotifyData.AlertUpdatedTime;
                
                    //line 1
                    if(AlertNotifyData.DeviceDetails != 'Pager Communication' && 
                        AlertNotifyData.TruViewEventType != Alert_Event_Type.Appliance_UPS_IN_Battery &&
                        AlertNotifyData.TruViewEventType != Alert_Event_Type.Appliance_UPS_OUT_Battery &&
                        AlertNotifyData.TruViewEventType != Alert_Event_Type.Appliance_UPS_Unplug && 
                        AlertNotifyData.TruViewEventType != Alert_Event_Type.Appliance_LostInternet)
                    strNotification += notification_line1(AlertNotifyData.Fontcolor ,AlertNotifyData.AlertNotifiedBy,alertlevelImg, AlertNotifyData.AlertTyp, AlertNotifyData.DeviceType, AlertNotifyData.AlertDescript)
                    //line 2
                    strNotification += notification_line2(Alert_TimeofAlert ,AlertNotifyData.Fontcolor,AlertNotifyData.AlertTime,1,AlertNotifyData.AlertId,AlertNotifyData.StrAckedData,AlertNotifyData.StatusDec)
                    //line 3
                    strNotification += notification_line3(AlertNotifyData.AlertSubName,AlertNotifyData.AlertType, AlertNotifyData.Fontcolor,AlertNotifyData.EventName,AlertNotifyData.TagId,AlertNotifyData.DeviceType, AlertNotifyData.SubTypeName, AlertNotifyData.AlertFulltypeName, AlertNotifyData.AlerttypeName, AlertNotifyData.TruViewEventType)
                    
                    
                    if (AlertNotifyData.AckStatus == enumAlertAckStatus.Accepted || AlertNotifyData.AckStatus == enumAlertAckStatus.Presence || AlertNotifyData.AckStatus == enumAlertAckStatus.Caregiver_Presence  || AlertNotifyData.AckStatus == enumAlertAckStatus.Caregiver_Alert_Presence || AlertNotifyData.AckStatus == enumAlertAckStatus.Complete || AlertNotifyData.AckStatus == enumAlertAckStatus.Cancel) {
                        //acked information                    
                        strNotification += notification_ackinfo(Staffphoto ,AlertNotifyData.AckedName ,AlertNotifyData.StatusDec ,AlertNotifyData.StrAckedData, AlertNotifyData.AckedMethod)
                    }
                                        
                    if (staffdetails && AlertNotifyData.AckStatus == enumAlertAckStatus.Notified && 
                        AlertNotifyData.DeviceDetails != 'Pager Communication' && 
                        AlertNotifyData.TruViewEventType != Alert_Event_Type.Appliance_UPS_IN_Battery && 
                        AlertNotifyData.TruViewEventType != Alert_Event_Type.Appliance_UPS_OUT_Battery &&
                        AlertNotifyData.TruViewEventType != Alert_Event_Type.Appliance_UPS_Unplug && 
                        AlertNotifyData.TruViewEventType != Alert_Event_Type.Appliance_LostInternet
                        ) {                                                
                        var notifystaffdetails = staffdetails.filter(function (e1) {
                            return ( e1.AlarmSubTypeId == AlertNotifyData.SubTypeId ); //&& AlertNotifyData.AckedTime == null
                        });
                        this.getNotificationdetails = notifystaffdetails;
                        this.cancel_TagId = AlertData[0].TagId
                        
                        if (notifystaffdetails.length > 0) {    
                            var ackedid = "";
                            for (var nnotify = 0; nnotify< notifystaffdetails.length; nnotify++) {

                                var alertnotifytime = "";
                                var alertnotifyseconds;
                                var format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
                            
                            
                                //////////staff details//////////
                                strNotification += '<div class="row">'

                                if (AlertNotifyData.AlertLevel == (nnotify+ 1)) {
                                    strNotification += '<div class="clsstaffinfo">';
                                    strNotification += '<table><tr><td class="clsalignleft">';
                                    if(AlertNotifyData.AlertNotifiedBy == "Notify")
                                    {
                                        strNotification += '<div><img src="assets/images/Alerts-NotificationPopup-Escalation' + AlertNotifyData.AlertLevel + '-Gray.png">\t\t'    
                                    }
                                    else
                                        strNotification += '<div><img src="assets/images/Alerts-NotificationPopup-Escalation' + AlertNotifyData.AlertLevel + '-Red.png">\t\t'

                                    if (notifystaffdetails[nnotify].StaffName != null && notifystaffdetails[nnotify].StaffName != '') {
                                        if (format.test(notifystaffdetails[nnotify].StaffName) == true) 
                                        {
                                            if (notifystaffdetails[nnotify].StaffName!=null)
                                            {
                                                if (notifystaffdetails[nnotify].StaffName.length>0)
                                                {
                                                    var SName = notifystaffdetails[nnotify].StaffName.split(',');
                                                    var staffFullName;                                                   
                                                    if (SName.length > 0) {
                                                        for (var s = 0; s < SName.length; s++) {
                                                            staffFullName = SName[s];                                                            
                                                            if (s == 0)
                                                            {
                                                                if(SName[s].length > 40)
                                                                {
                                                                    
                                                                    SName[s] = SName[s].slice(0, 20) + "..";                                                                                                                                  
                                                                    strNotification += '<div class="tooltip notfirstname">' + SName[s] + '<span class="tooltiptext">' + staffFullName + '</span></div>'
                                                                    strNotification += '<br>'
                                                                }
                                                                else
                                                                {
                                                                    strNotification += '<span class="notpopupfontSize notfirstname">' + SName[s] + '</span>'
                                                                    strNotification += '<br>'
                                                                }
                                                            }                                                                
                                                            else
                                                            {                                                                
                                                                if(SName[s].length > 40)
                                                                {
                                                                    
                                                                    SName[s] = SName[s].slice(0, 20) + "..";                                                                                                                                  
                                                                    strNotification += '<div class="tooltip notpopupfontSize clsnotifyname">' + SName[s] + '<span class="tooltiptext">' + staffFullName + '</span></div>' 
                                                                    strNotification += '<br>'
                                                                }
                                                                else
                                                                {                                                                    
                                                                    strNotification += '<span class="alignstaffroll notpopupfontSize">' + SName[s] + '</span>'
                                                                    strNotification += '<br>'
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else
                                        {
                                            strNotification +=notification_staffinfomration(notifystaffdetails[nnotify].StaffName,notifystaffdetails[nnotify].ContactNumber)
                                        }
                                    
                                    
                                    }
                                    if (notifystaffdetails[nnotify].Designation != null && notifystaffdetails[nnotify].Designation.trim() != '') {                                       
                                        if (format.test(notifystaffdetails[nnotify].Designation) == true) {                                           
                                            var Sdesignation = notifystaffdetails[nnotify].Designation.split(',');
                                            if (Sdesignation.length > 0) {
                                                for (var d = 0; d < Sdesignation.length; d++) {
                                                    if (d == 0)
                                                    {                                                                                                              
                                                        strNotification += '<span class="notpopupfontSize notfirstname">' + Sdesignation[d] + '</span>'
                                                        strNotification += '<br>'
                                                    }
                                                    else
                                                    {                                                        
                                                        strNotification += '<span class="alignstaffroll notpopupfontSize">' + Sdesignation[d] + '</span>'
                                                        strNotification += '<br>'
                                                    }
                                                }
                                            }
                                        }
                                        else
                                        {                                            
                                            strNotification += '<span class="notpopupfontSize notfirstname">' + notifystaffdetails[nnotify].Designation + '</span>'
                                            strNotification += '<br>'
                                        }
                                        
                                        
                                        
                                    }
                                    if (notifystaffdetails[nnotify].GroupName != '') {  
                                                                           
                                        if (format.test(notifystaffdetails[nnotify].GroupName) == true) {                                           
                                            var RSGroupName = notifystaffdetails[nnotify].GroupName.split(',');
                                            if (RSGroupName.length > 0) {
                                                for (var d = 0; d < RSGroupName.length; d++) {

                                                    if (d == 0)
                                                    {                                                                                                                            
                                                        groupName = RSGroupName[d];                                                                                                                
                                                        if(groupName.length >= 30)
                                                        {
                                                            groupFullName = groupName;
                                                            groupName = groupName.slice(0, 20) + "..";                                                                                                                                  
                                                            strNotification += '<div class="tooltip notfirstname">' + groupName + '<span class="tooltiptext">' + groupFullName + '</span></div>'
                                                            strNotification += '<br>'
                                                        }
                                                        else
                                                        {
                                                            strNotification += '<span class="notpopupfontSize notfirstname">' + groupName + '</span>'
                                                            strNotification += '<br>'
                                                        }                                                                                                                                                                        
                                                    }
                                                    else
                                                    {   
                                                        groupName = RSGroupName[d];                                                      
                                                        if(groupName.length >= 30)
                                                        {
                                                            groupFullName = groupName;
                                                            groupName = groupName.slice(0, 20) + "..";                                                                                                                                  
                                                            strNotification += '<div class="tooltip notfirstname">' + groupName + '<span class="tooltiptext">' + groupFullName + '</span></div>'                                                            
                                                            strNotification += '<br>'
                                                        }
                                                        else                                                        
                                                            strNotification += '<span class="alignstaffroll notpopupfontSize">' + groupName + '</span>'                                                        
                                                            strNotification += '<br>'
                                                    }
                                                    
                                                }
                                            }
                                        }
                                        else
                                        {                                            
                                            var groupName;
                                            var groupFullName;
                                            groupName = notifystaffdetails[nnotify].GroupName;
                                            
                                            if(groupName.length >= 30)
                                            {
                                                groupFullName = groupName;
                                                groupName = groupName.slice(0, 20) + "..";                                                                                                                                  
                                                strNotification += '<div class="tooltip notfirstname">' + groupName + '<span class="tooltiptext">' + groupFullName + '</span></div>'
                                                strNotification += '<br>'
                                            }
                                            else
                                            {
                                                strNotification += '<span class="notpopupfontSize notfirstname">' + groupName + '</span>'                                                            
                                                strNotification += '<br>'
                                            } 
                                        }
                                        
                                        
                                        
                                    }
                                    strNotification += '</div>'
                                    strNotification += '</td>'                                                                     
                                    strNotification += notification_buttons(AlertNotifyData.notifiedBtn1,AlertNotifyData.notifiedVal1 ,AlertNotifyData.notifiedBtn2,AlertNotifyData.notifiedVal2 , AlertNotifyData.notifiedBtn3,AlertNotifyData.notifiedVal3,alertnotifytime,nnotify)
                                    strNotification += '</div>';
                                    strNotification += '<hr class="clsline">'

                                }

                                else if (AlertNotifyData.AlertLevel > (nnotify + 1)) {
                                    strNotification += '<div class="clsstaffinfo">';
                                    strNotification += '<table><tr><td class="clsalignleft">';  
                                    if(AlertNotifyData.AlertNotifiedBy == "Notify")
                                    {
                                        strNotification += '<div><img src="assets/images/Alerts-NotificationPopup-Escalation' + (nnotify + 1) + '-Gray.png">\t\t'    
                                    }
                                    else                                 
                                        strNotification += '<div><img src="assets/images/Alerts-NotificationPopup-Escalation' + (nnotify + 1) + '-Red.png">\t\t'
                                    if (notifystaffdetails[nnotify].StaffName != null && notifystaffdetails[nnotify].StaffName != '') {
                                        if (format.test(notifystaffdetails[nnotify].StaffName) == true) 
                                        {
                                            var SName = notifystaffdetails[nnotify].StaffName.split(',');
                                            var staffFullName;
                                            if (SName.length > 0) {
                                                for (var s = 0; s < SName.length; s++) {
                                                    staffFullName = SName[s];
                                                    if (s == 0)
                                                    {
                                                        if(SName[s].length > 40)
                                                        {
                                                            
                                                            SName[s] = SName[s].slice(0, 20) + "..";                                                                                                                                  
                                                            strNotification += '<div class="tooltip notfirstname">' + SName[s] + '<span class="tooltiptext">' + staffFullName + '</span></div>'
                                                            strNotification += '<br>'
                                                        }
                                                        else
                                                        {
                                                            strNotification += '<span class="notpopupfontSize notfirstname">' + SName[s] + '</span>'
                                                            strNotification += '<br>'                                                            
                                                        }
                                                    }
                                                    else
                                                    {                                                                
                                                        if(SName[s].length > 40)
                                                        {
                                                            
                                                            SName[s] = SName[s].slice(0, 20) + "..";                                                                                                                                  
                                                            strNotification += '<div class="tooltip notpopupfontSize clsnotifyname">' + SName[s] + '<span class="tooltiptext">' + staffFullName + '</span></div>'
                                                            strNotification += '<br>'
                                                        }
                                                        else
                                                        {                                                            
                                                            strNotification += '<span class="alignstaffroll notpopupfontSize">' + SName[s] + '</span>'
                                                            strNotification += '<br>'
                                                        }
                                                    }                                                                                                            
                                                }
                                            }
                                        }
                                        else
                                        {
                                            strNotification +=notification_staffinfomration(notifystaffdetails[nnotify].StaffName,notifystaffdetails[nnotify].ContactNumber)
                                        }
                                                                        
                                    }
                                    if (notifystaffdetails[nnotify].Designation != null && notifystaffdetails[nnotify].Designation.trim() != '') {                                       
                                        if (format.test(notifystaffdetails[nnotify].Designation) == true) {                                           
                                            var Sdesignation = notifystaffdetails[nnotify].Designation.split(',');
                                            if (Sdesignation.length > 0) {
                                                for (var d = 0; d < Sdesignation.length; d++) {
                                                    if (d == 0)
                                                    {                                                       
                                                         strNotification += '<span class="notpopupfontSize notfirstname">' + Sdesignation[d] + '</span>'
                                                         strNotification += '<br>'
                                                    }
                                                       
                                                    else
                                                    {
                                                        strNotification += '<span class="alignstaffroll notpopupfontSize">' + Sdesignation[d] + '</span>'
                                                        strNotification += '<br>'
                                                    }
                                                }
                                            }
                                        }
                                        else
                                        {                                            
                                            strNotification += '<span class="notpopupfontSize notfirstname">' + notifystaffdetails[nnotify].Designation + '</span>'
                                            strNotification += '<br>'
                                        }
                                        
                                      
                                        
                                    }
                                    if (notifystaffdetails[nnotify].GroupName != '') {  
                                        
                                        if (format.test(notifystaffdetails[nnotify].GroupName) == true) {                                           
                                            var RSGroupName = notifystaffdetails[nnotify].GroupName.split(',');
                                            if (RSGroupName.length > 0) {                                                
                                                for (var d = 0; d < RSGroupName.length; d++) {

                                                    if (d == 0)
                                                    {                                                                                                                            
                                                        groupName = RSGroupName[d];                                                                                                                
                                                        if(groupName.length >= 30)
                                                        {
                                                            groupFullName = groupName;
                                                            groupName = groupName.slice(0, 20) + "..";                                                                                                                                  
                                                            strNotification += '<div class="tooltip notfirstname">' + groupName + '<span class="tooltiptext">' + groupFullName + '</span></div>'
                                                            strNotification += '<br>'
                                                        }
                                                        else
                                                        {
                                                            strNotification += '<span class="notpopupfontSize notfirstname">' + groupName + '</span>'
                                                            strNotification += '<br>'
                                                        }                                                                                                                                                                        
                                                    }
                                                    else
                                                    {   
                                                        groupName = RSGroupName[d];                                                      
                                                        if(groupName.length >= 30)
                                                        {
                                                            groupFullName = groupName;
                                                            groupName = groupName.slice(0, 20) + "..";                                                                                                                                  
                                                            strNotification += '<div class="tooltip notfirstname">' + groupName + '<span class="tooltiptext">' + groupFullName + '</span></div>'                                                            
                                                            strNotification += '<br>'
                                                        }
                                                        else                                                        
                                                            strNotification += '<span class="alignstaffroll notpopupfontSize">' + groupName + '</span>'                                                        
                                                            strNotification += '<br>'
                                                    }
                                                    
                                                }
                                            }
                                        }
                                        else
                                        {                
                                            var groupName;
                                            var groupFullName;
                                            groupName = notifystaffdetails[nnotify].GroupName;
                                            
                                            if(groupName.length >= 30)
                                            {
                                                groupFullName = groupName;
                                                groupName = groupName.slice(0, 20) + "..";                                                                                                                                  
                                                strNotification += '<div class="tooltip notfirstname">' + groupName + '<span class="tooltiptext">' + groupFullName + '</span></div>'
                                                strNotification += '<br>'
                                            }
                                            else
                                            {
                                                strNotification += '<span class="notpopupfontSize notfirstname">' + groupName + '</span>'                                                            
                                                strNotification += '<br>'
                                            }                                                                                                    
                                        }                                                                                
                                                                                
                                    }
                                    strNotification += '</div>'
                                    strNotification += '</td>'                          
                                    strNotification += notification_buttons(AlertNotifyData.notifiedBtn1,AlertNotifyData.notifiedVal1 ,AlertNotifyData.notifiedBtn2,AlertNotifyData.notifiedVal2 , AlertNotifyData.notifiedBtn3,AlertNotifyData.notifiedVal3,alertnotifytime,nnotify)
                                    strNotification += '</div>';
                                    strNotification += '<hr class="clsline">'
                                }
                                else {
                                    strNotification += '<div class="clsstaffinfo">';
                                    strNotification += '<table><tr><td class="clsalignleft">';
                                    strNotification += '<div><img src="assets/images/Alerts-NotificationPopup-Escalation' + (nnotify + 1) + '-Gray.png">\t\t'
                                    if (notifystaffdetails[nnotify].StaffName != null && notifystaffdetails[nnotify].StaffName != '') {
                                        if (format.test(notifystaffdetails[nnotify].StaffName) == true) 
                                        {
                                            var SName = notifystaffdetails[nnotify].StaffName.split(',');
                                            var staffFullName;
                                            if (SName.length > 0) {
                                                for (var s = 0; s < SName.length; s++) {
                                                    staffFullName = SName[s];
                                                    if (s == 0)
                                                    {
                                                        if(SName[s].length > 40)
                                                        {
                                                            
                                                            SName[s] = SName[s].slice(0, 20) + "..";                                                                                                                                  
                                                            strNotification += '<div class="tooltip notfirstname">' + SName[s] + '<span class="tooltiptext">' + staffFullName + '</span></div>'
                                                            strNotification += '<br>'
                                                        }
                                                        else
                                                        {
                                                            strNotification += '<span class="notpopupfontSize notfirstname">' + SName[s] + '</span>'
                                                            strNotification += '<br>'
                                                        }
                                                    }
                                                    else
                                                    {                                                                
                                                        if(SName[s].length > 40)
                                                        {
                                                            
                                                            SName[s] = SName[s].slice(0, 20) + "..";                                                                                                                                  
                                                            strNotification += '<div class="tooltip notpopupfontSize clsnotifyname">' + SName[s] + '<span class="tooltiptext">' + staffFullName + '</span></div>'                                                            
                                                        }
                                                        else
                                                        {                                                            
                                                            // strNotification += '<br>'
                                                            strNotification += '<span class="alignstaffroll notpopupfontSize">' + SName[s] + '</span>'       
                                                            strNotification += '<br>'                                                     
                                                        }
                                                    }                                                        
                                                }
                                            }
                                        }
                                        else
                                        {
                                            strNotification +=notification_staffinfomration(notifystaffdetails[nnotify].StaffName,notifystaffdetails[nnotify].ContactNumber)
                                        }                                    
                                    
                                    }
                                    if (notifystaffdetails[nnotify].Designation != null && notifystaffdetails[nnotify].Designation.trim() != '') {
                                        if (format.test(notifystaffdetails[nnotify].Designation) == true) {                                            
                                            var Sdesignation = notifystaffdetails[nnotify].Designation.split(',');
                                            if (Sdesignation.length > 0) {
                                                for (var d = 0; d < Sdesignation.length; d++) {
                                                    if (d == 0)
                                                    {                                                      
                                                        strNotification += '<span class="notpopupfontSize notfirstname">' + Sdesignation[d] + '</span>'
                                                        strNotification += '<br>'
                                                    }
                                                        
                                                    else
                                                    {
                                                        strNotification += '<span class="alignstaffroll notpopupfontSize">' + Sdesignation[d] + '</span>'
                                                        strNotification += '<br>'
                                                    }
                                                }
                                            }
                                        }
                                        else
                                        {                                            
                                            strNotification += '<span class="notpopupfontSize notfirstname">' + notifystaffdetails[nnotify].Designation + '</span>'
                                            strNotification += '<br>'
                                        }
                                        
                                       
                                        
                                    }
                                    if (notifystaffdetails[nnotify].GroupName != '') {                                                                              
                                        if (format.test(notifystaffdetails[nnotify].GroupName) == true) {                                           
                                            var RSGroupName = notifystaffdetails[nnotify].GroupName.split(',');                                            
                                            if (RSGroupName.length > 0) {
                                                var groupName;
                                                var groupFullName;
                                                for (var d = 0; d < RSGroupName.length; d++) {

                                                    if (d == 0)
                                                    {                                                                                                                            
                                                        groupName = RSGroupName[d];                                                                                                                
                                                        if(groupName.length >= 30)
                                                        {
                                                            groupFullName = groupName;
                                                            groupName = groupName.slice(0, 20) + "..";                                                                                                                                  
                                                            strNotification += '<div class="tooltip notfirstname">' + groupName + '<span class="tooltiptext">' + groupFullName + '</span></div>'
                                                            strNotification += '<br>'
                                                        }
                                                        else
                                                        {
                                                            strNotification += '<span class="notpopupfontSize notfirstname">' + groupName + '</span>'
                                                            strNotification += '<br>'
                                                        }                                                                                                                                                                        
                                                    }
                                                    else
                                                    {   
                                                        groupName = RSGroupName[d];                                                      
                                                        if(groupName.length >= 30)
                                                        {
                                                            groupFullName = groupName;
                                                            groupName = groupName.slice(0, 20) + "..";                                                                                                                                  
                                                            strNotification += '<div class="tooltip notfirstname">' + groupName + '<span class="tooltiptext">' + groupFullName + '</span></div>'                                                            
                                                            strNotification += '<br>'
                                                        }
                                                        else                                                        
                                                            strNotification += '<span class="alignstaffroll notpopupfontSize">' + groupName + '</span>'                                                        
                                                            strNotification += '<br>'
                                                    }
                                                    
                                                }
                                            }
                                        }
                                        else
                                        {                 
                                            var groupName;
                                            var groupFullName;
                                            groupName = notifystaffdetails[nnotify].GroupName;
                                            
                                            if(groupName.length >= 30)
                                            {
                                                groupFullName = groupName;
                                                groupName = groupName.slice(0, 20) + "..";                                                                                                                                  
                                                strNotification += '<div class="tooltip notfirstname">' + groupName + '<span class="tooltiptext">' + groupFullName + '</span></div>'
                                                strNotification += '<br>'
                                            }
                                            else
                                            {
                                                strNotification += '<span class="notpopupfontSize notfirstname">' + groupName + '</span>'
                                                strNotification += '<br>'
                                            }
                                                                                        
                                        }
                                        
                                        
                                        
                                    }
                                    strNotification += '</div>'  
                                    strNotification += '</td>'                                                  
                                    strNotification += notification_buttons(AlertNotifyData.notifiedBtn1,AlertNotifyData.notifiedVal1 ,AlertNotifyData.notifiedBtn2,AlertNotifyData.notifiedVal2 , AlertNotifyData.notifiedBtn3,AlertNotifyData.notifiedVal3,alertnotifytime,nnotify)
                                    strNotification += '</div>';
                                    strNotification += '<hr class="clsline">'
                                }
                                strNotification += '</div>'
                            
                            }


                            ////////////////////////////Nearest Staff/////////////////                        
                            var nstaffdetails = notifystaffdetails;
                            var NearestStaff = [];

                            if (NearestStaffDetails) {
                                NearestStaff = NearestStaffDetails;
                                if (NearestStaff.length > 0) {
                                    //neares staff heading   
                                    strNotification += notification_neareststaff_heading()
                                    for (var s = 0; s < NearestStaff.length; s++) {
                                        //neares staff details
                                        strNotification += notification_neareststaff_details(NearestStaff[s].FirstName,NearestStaff[s].ContactNumber)
                                    }

                                }
                                NearestStaff = [];
                                NearestStaffDetails = [];

                            }
                        }
                    }
        //////////////////////////////END////////////////////////
                    var bNeedShow=true;
                      if ((AlertNotifyData.AlertType==enumAlertType.Pendant || AlertNotifyData.AlertType==enumAlertType.Pull_Cord) && localStorage.getItem("ENABLE_UL2560") =="1")
                      {
                        bNeedShow=false;
                    }                    

                    if (bNeedShow ==true)  //thisis check ENABLE_UL2560 is true then don't cancel the alert for Geo Pedant and Pullcord alerts.
                    {
                        if(getFeatureNeedtoShow(enumUIFeatureView.Home, enumUIAction.Alert_Cancel) == enumUIView.Show &&  AlertNotifyData.AckStatus != enumAlertAckStatus.Cancel)
                        {                                                         
                            if(AlertNotifyData.AlertType==enumAlertType.Pull_Cord)
                            {
                                strNotification += '<div class="row clsclearDiv1">';                                        
                                strNotification += '<span class="notSeconddiv notDisableClearAlert" style="background-color:#b5b6b8;pointer-events: none;" id="divClearAlert" data-CancelId=' + AlertNotifyData.AlertId + '>';                         
                                strNotification += 'Cancel Alert';
                                strNotification += '</span>';
                                strNotification += '</div>'; 
                            }    
                            else{                                              
                                strNotification += '<div class="row clsclearDiv1">';                                        
                                strNotification += '<span class="notSeconddiv notClearAlert" id="divClearAlert" data-CancelId=' + AlertNotifyData.AlertId + '>';                         
                                strNotification += 'Cancel Alert';
                                strNotification += '</span>';
                                strNotification += '</div>';  
                            }                     
                        } 
                        else
                        {
                            strNotification += '<div class="row clsclearDiv1">';                                        
                            strNotification += '<span>&nbsp;</span>';
                            strNotification += '</div>';                       

                        }
                    }
                   else
                   {
                        strNotification += '<div class="row clsclearDiv1">';                                        
                        strNotification += '<span>&nbsp;</span>';
                        strNotification += '</div>';                       

                   }
                    strNotification += '</div>'
                    strNotification += '</div>'

                }
                return strNotification;
            }
            catch (err) {
                throw new Error('alertnotification.component.ts' + ' - shownotificationDetails() - ' + err.message);
            }              
    }


    CallaccessCode(e) {

        try {  
                    e = e || window.event;
                    var target = e.target || e.srcElement;                              

                    if (target.className == "notSeconddiv notClearAlert") {                                               
                        let notClearAlert= this.document.getElementsByClassName('notClearAlert');
                        notClearAlert[0].className="notClearAlert notSeconddiv DisableClearAlert";
                        
                        if(this.getNotificationdetails == undefined || this.getNotificationdetails.length > 0)                        
                           this.cancelnotifypopup();                                                        
                        else
                        {
                            this.cancelnotifypopup();                                                            
                            this.ReloadOpenAlert();
                        }
                    }                   
                    else if(target.className == "notReNotify_1" || target.className == "notReNotify_2" || target.className == "notReNotify_3" 
                            || target.className == "notNotified_1" || target.className == "notNotified_2"|| target.className == "notNotified_3" || target.className == "notNotify_2" ||target.className == "notNotify_3")
                    {  
                        var stafflevel = target.className;
                            stafflevel = stafflevel.split("_");
                        var UpdateLevel= 0;

                            if(stafflevel[1] == 1)                                 
                                this.getclassname = target.className;
                                            
                            else if(stafflevel[1] == 2)                                 
                                this.getclassname = target.className;
                                            
                            else if(stafflevel[1] == 3)                                  
                                this.getclassname = target.className;
                            
                                

                        if(target.className == "notNotify_2" ||target.className == "notNotify_3")
                        {
                            UpdateLevel = 1;
                        }            
                        var notifiedItem : reNotifyAlert = 
                        {
                            siteId:this.SiteId,
                            authKey: localStorage.getItem("Authkey"),
                            alertId:this.AlertID,
                            level:parseInt(stafflevel[1]),
                            updateLevel:UpdateLevel,
                            alertType:this.AlertType
                        }
                        this.renotifyAlert(notifiedItem);
                    }
            }
            catch (err) {
                    throw new Error('alertnotification.component.ts' + ' - CallaccessCode() - ' + err.message);
            }                       
    }

    cancelnotifypopup() {
        if(!SessionCheck(this.router))
        {
            this.thisDialogRef.close('Cancel');
            return;
        }
        if (localStorage.getItem("userid")==null)
        {
            localStorage.clear();
            this.router.navigate(['/login']);
        }        
        var cancelAlertId = this.AlertID;
        var getcancelalertdata = this.AlertData;                
        var ConfirmMessageData = {
            ConfirmMessage: "Are you sure you want to Cancel this Alert?"
          }     
          let dialogRef = this.dialog.open(ConfirmMessageComponent, {
            disableClose: true,
            width: 'auto',
            height: 'auto',
            panelClass: 'myapp-no-padding-dialog',
            autoFocus: false,
            data: ConfirmMessageData
          });
          var _thisDialogRef=this.thisDialogRef;
          dialogRef.afterClosed().subscribe(result => {
            if(result == "Yes")
            {
                
                try {  
                    if(!SessionCheck(this.router))
                    {
                      this.thisDialogRef.close('Cancel');
                        return;
                    }
                    this.alertreturnVal = 1;
                    var cancelAlertflag =0
                    var cancelItem : cancelAlert = 
                    {
                        siteId:this.SiteId, 
                        authKey: localStorage.getItem("Authkey"), 
                        staffId:parseInt(localStorage.getItem("userid")), 
                        alertId:parseInt(this.AlertID), 
                        status:enumAlertStatus.Canceled
                    }
                    this.apiService.cancelAlert(cancelItem).pipe(takeUntil(this._onDestroy))
                    .subscribe((canceledResponse: any[]) => {
                        if(canceledResponse["apiReturn"] == "Success")
                          generateAlertMessage(this.dialog, 'Alert cancelled successfully.');      
                          if(getcancelalertdata[0].DeviceDetails == 'Pager Communication')                   
                            this.apiService.reloadPagerAlert();
                          this.notify_alive = false; 
                          this.thisDialogRef.close('CanceledAlert');                      
                    });
                   
                    var _SharedAlertLoadDetails = {
                      "SharedreturnVal":  this.alertreturnVal,
                      "SharedNotifiedVal": 9,
                      "AlertId":this.AlertID
                    };
          
                    this.alertSharedService.changecanceledAlert(_SharedAlertLoadDetails);
                    
                }
              catch (err) {
                  throw new Error('clearalert.component.ts - onClickedYes() - ' + err.message);
                }  
            }
            else{               
                    let notClearAlert= this.document.getElementsByClassName('notClearAlert');
                    notClearAlert[0].className="notSeconddiv notClearAlert";
                    return false;                
            }
          });
    }

  
    renotifyAlert(notifiedItem)
    {
        
        if(!SessionCheck(this.router))
        {
            this.thisDialogRef.close('Cancel');
            return;
        }
        try {                
                this.loading = true;
                let elementcontent = document.getElementById('divnotifycontent');
                elementcontent.className = 'divNotify disablecontent'
                
                this.notify_status = true;
                this.notify_alive = false;        
                this.checkdayforall = 0;
                this.checktimeforalert = 0;
                
                //check the internet connection found or not.
            
                this.checknetwork = AppComponent.SharedInternetConnection;
                if (this.checknetwork != undefined) {
                    if (this.checknetwork == 0) {
                        generateAlertMessage(this.dialog, "Notification failed, due to no Internet connectivity.")
                        this.loading = false; 
                        elementcontent.className = 'divNotify enablecontent'    
                    } 
                    else
                    {     
                            this.homeService.renotifyAlert(notifiedItem).pipe(takeUntil(this._onDestroy))
                            .subscribe((NotifiedResponse: any[]) => {                  
                                if(NotifiedResponse["apiReturn"] == "Success")
                                {                       
                                    this.getRenotifyData();
                                }
                                else if (NotifiedResponse["apiReturn"] == "Invalid Auth Key") {
                                    this.thisDialogRef.close("Cancel");                                   
                                    return;
                                  }
                                else
                                {
                                    this.loading = false; 
                                    elementcontent.className = 'divNotify enablecontent'                                              
                                    generateAlertMessage(this.dialog, "Notification failed, please retry.")
                                }
                                
                            });  
                        }
                 }
            

            }
            catch (err) {
                    throw new Error('alertnotification.component.ts' + ' - renotifyAlert() - ' + err.message);
            }  
    }

    ReloadOpenAlert()
    {
        try
        {            
            
            var AlertData = {AlertId:this.AlertID,TagId:this.cancel_TagId}             
            this.http.get(this.ReloadOpenAlertURL, {params: AlertData}).pipe(takeUntil(this._onDestroy)).subscribe((res) => {
            })           
        }
            catch (err) {
            throw new Error('Notification.service.ts' + ' - reloadlive() - ' + err.message);
        }
    }

ngOnDestroy() {
	this._onDestroy.next();
	this._onDestroy.complete();
}
   
}
